import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setReturnInfo"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`items`}</inlineCode>{` - Array of `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returninfodraft"
          }}>{`ReturnInfoDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`Items to be returned.`}</li>
      </ul>
      <p parentName="section">{`This update action produces the `}<a parentName="p" {...{
          "href": "/api/../api/message-types#returninfoset-message"
        }}>{`ReturnInfoSetMessage`}</a>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      